/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetModelsHierarchyResult } from '../../models/get-models-hierarchy-result';

export interface ApiAdminModelsHierarchyGet$Params {
  modelTypeId?: string;
  includeAll?: boolean;
}

export function apiAdminModelsHierarchyGet(http: HttpClient, rootUrl: string, params?: ApiAdminModelsHierarchyGet$Params, context?: HttpContext): Observable<StrictHttpResponse<GetModelsHierarchyResult>> {
  const rb = new RequestBuilder(rootUrl, apiAdminModelsHierarchyGet.PATH, 'get');
  if (params) {
    rb.query('modelTypeId', params.modelTypeId, {});
    rb.query('includeAll', params.includeAll, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetModelsHierarchyResult>;
    })
  );
}

apiAdminModelsHierarchyGet.PATH = '/api/Admin/models/hierarchy';
